import type { ApolloError } from '@apollo/client';
import { reportToSentry } from '@sonnen/web-utils';

/**
 * Logs address validation refetch error to Sentry
 */
export const logAddressRefetchError = (error: Error | ApolloError, offerError?: string) => {
  reportToSentry('Address validation refetch failed', {
    tag: 'address_validation',
    level: 'warning',
    context: {
      component: 'AdditionalAddress',
      event: 'refetch_error',
      offerError,
      error: error?.message || 'Unknown error',
    },
  });
};
